var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Logo",
    d: "M21.4881 10.2046H20.7497V10.1666H12.4997V13.8333H17.6802C16.9244 15.9677 14.8935 17.4999 12.4997 17.4999C9.4623 17.4999 6.99967 15.0373 6.99967 11.9999C6.99967 8.96254 9.4623 6.49992 12.4997 6.49992C13.9017 6.49992 15.1773 7.02884 16.1485 7.89279L18.7413 5.3C17.1041 3.77421 14.9142 2.83325 12.4997 2.83325C7.43738 2.83325 3.33301 6.93763 3.33301 11.9999C3.33301 17.0622 7.43738 21.1666 12.4997 21.1666C17.562 21.1666 21.6663 17.0622 21.6663 11.9999C21.6663 11.3853 21.6031 10.7853 21.4881 10.2046Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo_2",
    d: "M4.38965 7.73329L7.40136 9.942C8.21627 7.92442 10.1899 6.49992 12.4994 6.49992C13.9014 6.49992 15.177 7.02884 16.1482 7.89279L18.741 5.3C17.1038 3.77421 14.9139 2.83325 12.4994 2.83325C8.97848 2.83325 5.92507 4.82104 4.38965 7.73329Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo_3",
    d: "M12.5005 21.1667C14.8682 21.1667 17.0196 20.2606 18.6463 18.7871L15.8092 16.3863C14.8888 17.0834 13.7448 17.5001 12.5005 17.5001C10.1162 17.5001 8.09176 15.9798 7.32909 13.8582L4.33984 16.1613C5.85693 19.1299 8.93784 21.1667 12.5005 21.1667Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo_4",
    d: "M21.4884 10.2048H20.75V10.1667H12.5V13.8334H17.6805C17.3175 14.8587 16.658 15.7428 15.8073 16.3868C15.8078 16.3863 15.8082 16.3863 15.8087 16.3859L18.6458 18.7866C18.445 18.969 21.6667 16.5834 21.6667 12.0001C21.6667 11.3855 21.6034 10.7855 21.4884 10.2048Z",
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.7e8fa4df9b7a5be447dbad3e8dc268f6.svg";
export { ForwardRef as ReactComponent };